import { Indicator, Root } from '@radix-ui/react-checkbox'
import { cn } from '@seen/ui'
import { IconCheck } from '@tabler/icons-react'
import type { ComponentProps } from 'react'

export interface CheckboxProps extends Omit<
  ComponentProps<typeof Root>,
  'value' | 'onChange' | 'checked' | 'onCheckedChange'
> {
  value?: boolean
  onChange?: (value: boolean) => void
}

export function Checkbox({
  className,
  value,
  onChange,
  ...props
}: CheckboxProps) {
  return (
    <Root
      data-slot="checkbox"
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border border-input outline-hidden transition-shadow focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:data-[state=checked]:bg-primary dark:aria-invalid:ring-destructive/40',
        className
      )}
      checked={value}
      onCheckedChange={onChange}
      {...props}
    >
      <Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <IconCheck className="size-3.5" />
      </Indicator>
    </Root>
  )
}
